import {PayoutModel} from "../constants/PickXEnums";
import Pick12PayoutCalculator from "../services/Pick12ParlayPayoutCalculator";
import Pick16PayoutCalculator from "../services/Pick16ParlayPayoutCalculator";
import PrizeAssetsPayoutCalculator from "../services/PrizeAssetsPayoutCalculator";

export default class PreSelectedParlay {

    Id
    Name
    ContestIds
    Status
    IsOnLobby
    Payout
    PayoutCurrency
    Fee
    FeeCurrency
    DateStart
    DateCreated
    DateExpired
    IsExpired
    SportIds
    PayoutModel

    constructor(data){
        Object.assign(this, data);
    }

    getPayouts({rollingPrize, prizeAsset}){
        let payoutInfos = [];
        switch(this.PayoutModel) {
            case PayoutModel.Pick12:
            case PayoutModel.Pick16:
                payoutInfos = new (this.ContestIds.length === 12 ? Pick12PayoutCalculator : Pick16PayoutCalculator)().calculateDistribution(this.Fee, rollingPrize?.RollingAmount ?? 0.0)
                break;
            case PayoutModel.Assets:
                payoutInfos = new PrizeAssetsPayoutCalculator().calculateDistribution(this.Fee, prizeAsset)
                break;
        }
        return payoutInfos;
    }
}